//Styles
import myStyles from "../../../../../styles/assessments/ManagementFormulaBuilder.module.css"

export default function FormulaBuilderLegend() {
  const Legend = ({ color, description }) => {
    return (
      <div className={myStyles.legendContainer}>
        <div
          className={myStyles.legendBlock}
          style={{ backgroundColor: color }}
        />
        <div>
          <label>{description}</label>
        </div>
      </div>
    )
  }

  return (
    <div className={myStyles.legendLayout}>
      <div
        className={`${myStyles.legendLayoutFunctions} ${myStyles.legendField}`}
      >
        <Legend color={"#873CAA"} description={"Functions"} />
      </div>
      <div className={`${myStyles.legendLayoutFields} ${myStyles.legendField}`}>
        <Legend color={"#E7E0F1"} description={"Fields (variables)"} />
      </div>
      <div
        className={`${myStyles.legendLayoutOperators} ${myStyles.legendField}`}
      >
        <Legend color={"#686E75"} description={"Arithmetic operators"} />
      </div>
      <div className={`${myStyles.legendLayoutGroups} ${myStyles.legendField}`}>
        <Legend
          color={"#C682E6"}
          description={"Parenthesis (for calc grouping and \nfunction context)"}
        />
      </div>
    </div>
  )
}
